export class DemandesComplementPiecesService {
    #demandesComplementPiecesAdapter;
    constructor({ demandesComplementPiecesAdapter }) {
        this.#demandesComplementPiecesAdapter = demandesComplementPiecesAdapter;
    }
    /**
     * get demande complement pieces with pieces.documents expanded
     *
     * @param demandeComplementPiecesId - demande complement pieces id
     * @returns demande complement pieces with pieces.documents expanded
     */
    async getWithDocuments(demandeComplementPiecesId) {
        const result = await this.#demandesComplementPiecesAdapter.getWithDocuments(demandeComplementPiecesId);
        if ('error' in result) {
            throw result.error;
        }
        return result.response;
    }
    /**
     * update demande complement pieces
     *
     * @param demandeComplementPieces - full demande complement pieces entity to update
     * @returns updated demande complement pieces
     */
    async update(demandeComplementPieces) {
        const result = await this.#demandesComplementPiecesAdapter.update(demandeComplementPieces);
        if ('error' in result) {
            throw result.error;
        }
        return result.response;
    }
}
//# sourceMappingURL=demandes-complement-pieces.service.js.map